import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { OrderStatusResponse } from '../../../../models/orders/order.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-select-status-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './select-status-dialog.component.html',
  styleUrl: './select-status-dialog.component.scss'
})
export class SelectStatusDialogComponent {

  selectedStatus: OrderStatusResponse | null = null;

  constructor(
    public dialogRef: MatDialogRef<SelectStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { statuses: OrderStatusResponse[] }
  ) {
     if (this.data?.statuses?.length > 0) {
       this.selectedStatus = this.data.statuses[0];
     }
  }

  onCancelClick(): void {
    this.dialogRef.close(); // Close without returning data
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedStatus); // Close and return the selected status
  }
}